































// vendor
import { defineComponent, PropType, computed, set } from "@vue/composition-api";
// project
import { getDeepProperty as getDeepObjectProperty } from "@/utils/object";
// local
import { FormSection } from "../ts/types";

type SectionInfo = {
	index:number,
	count:number
};

const shuffleOptions = [
	{ text: "None", value: null },
	{ text: "Shuffle", value: "shuffle" },
	{ text: "Pick One", value: "select" }
];

export default defineComponent({

	props:{
		sectionData:{
			type:Object as PropType<FormSection>,
			required:true
		},
		info:{
			type:Object as PropType<SectionInfo>,
			required:true
		}
	},
	setup(props){

		const itemSelection = computed({
			get: () => props.sectionData.settings ? props.sectionData.settings.itemSelection : null,
			set:v => {
				if(!props.sectionData){ return; }
				
				if(!props.sectionData.settings){
					set(props.sectionData, "settings", {
						itemSelection:null
					});
				}
				

				set(props.sectionData.settings, "itemSelection", v);
			}
		});

		return {
			shuffleOptions,
			itemSelection
		};
	}

});

